import { motion } from 'framer-motion';

const PrivacyHeroSection = () => {
  return (
    <section className="text-black py-24 min-h-[400px] flex items-center bg-white/50 ">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.h1 
            className="text-5xl font-bold mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Privacy Policy
          </motion.h1>
          <motion.p 
            className="text-xl text-black max-w-3xl md:pt-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Your privacy is important to us. This Privacy Statement explains how we collect, use, and protect your personal information.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyHeroSection; 